import _StoreData from './storedataredesign.json';

interface Data {
    [key: string]: DataStore[];
}
interface DataStore {
    item: string;
    shelf_life: number;
    lead_time: number;
    values: DataOrderedByShelf;
    prep: number[][];
    actual_waste: number[];
    actual_stockout: number[];
}

interface DataOrderedByShelf {
    [key: string]: DataOrderedByLead;
}

interface DataOrderedByLead {
    [key: string]: Datum;
}

interface Datum {
    prioritization: number;
    waste: number[][];
    stockout: number[][];
    waste_amount: number[][];
    stockout_amount: number[][];
}

const StoreData = _StoreData as Data;

const DaysOfTheWeek = ['Mon', 'Tues', 'Weds', 'Thurs', 'Fri', 'Sat', 'Sun'];

function data_waste(
    our_waste: number[][][],
    their_waste: number[][],
    sliders: number[]
) {
    return [0, 1, 2, 3, 4, 5, 6].map((counter) => {
        return {
            day: DaysOfTheWeek[counter],
            Current: their_waste[counter]
                .reduce((accumulator: number, value) => {
                    return accumulator + value;
                }, 0)
                .toFixed(),
            CurrentColor: '#BEC1C2',
            CurrentResponsiveColor: '#5F6061',
            ClearCOGS: our_waste[counter]
                .reduce((accumulator: number, value, index: number) => {
                    return accumulator + value[sliders[index]];
                }, 0)
                .toFixed(),
            ClearCOGSColor: '#2196F3',
            ClearCOGSResponsiveColor: '#104B79',
        };
    });
}

function data_stockout(
    leadTimes: number[],
    shelfLifes: number[],
    sliders: number[]
) {
    return [0, 1, 2, 3].map((counter) => {
        return {
            day: DaysOfTheWeek[counter],
            Current: StoreData.s7002.reduce((accumulator: number, object) => {
                return accumulator + object.actual_stockout[counter];
            }, 0),
            CurrentColor: 'hsl(200, 50%, 80%)',
            ClearCOGS: StoreData.s7002.reduce(
                (accumulator: number, object, index: number) => {
                    return (
                        accumulator +
                        object.values[leadTimes[index]][shelfLifes[index]]
                            .stockout[sliders[index]][counter]
                    );
                },
                0
            ),
            ClearCOGSColor: 'hsl(200, 70%, 50%)',
        };
    });
}

function data_heatmap(
    leadTimes: number[],
    shelfLifes: number[],
    sliders: number[]
) {
    return StoreData.s7002.map((item, index) => {
        let wasteTemp, stockoutTemp;
        return {
            id: item.item,
            data: [
                {
                    x: 'Waste',
                    y: (wasteTemp = item.values[leadTimes[index]][
                        shelfLifes[index]
                    ].waste_amount[sliders[index]].reduce(
                        (accumulator: any, value: any) => {
                            return accumulator + value;
                        },
                        0
                    )),
                },
                {
                    x: 'Stock Out',
                    y: (stockoutTemp = item.values[leadTimes[index]][
                        shelfLifes[index]
                    ].stockout[sliders[index]].reduce(
                        (accumulator: any, value: any) => {
                            return accumulator + value;
                        },
                        0
                    )),
                },
                {
                    x: 'Ratio',
                    y: stockoutTemp !== 0 ? wasteTemp / stockoutTemp : null,
                },
            ],
        };
    });
}

const data_shelflife_default: number[] = StoreData.s7002.map(
    (item: DataStore) => {
        return item.shelf_life;
    }
);

const data_shelflife_options: string[][] = StoreData.s7002.map(
    (item: DataStore) => {
        return Object.keys(item.values);
    }
);

const data_leadtime_default: number[] = StoreData.s7002.map(
    (item: DataStore) => {
        return item.lead_time;
    }
);

const data_leadtime_options: string[][] = StoreData.s7002.map(
    (item: DataStore, index: number) => {
        return Object.keys(item.values[data_shelflife_default[index]]);
    }
);

const data_prioritization_default: number[] = [2, 2, 2, 2, 2];

function data_preplist() {
    let variant1 = Math.random() < 0.5 ? 4 : -4;
    let variant2 = Math.random() < 0.7 ? 0.5 : -0.5;
    let variant3 = Math.random() < 0.3 ? 3 : -3;
    let variant4 = Math.random() < 0.8 ? 0.5 : -0.5;
    let variant5 = Math.random() < 0.2 ? 1 : -1;

    return [
        [
            [41, 45, 48, 51, 55],
            [3, 3.5, 4, 4.5, 5],
            [27, 30, 32, 34, 37],
            [2.5, 3, 3.5, 4, 4.5],
            [22, 25, 27, 29, 32],
        ],
        [
            [
                41 + variant1,
                45 + variant1,
                48 + variant1,
                51 + variant1,
                55 + variant1,
            ],
            [
                3 + variant2,
                3.5 + variant2,
                4 + variant2,
                4.5 + variant2,
                5 + variant2,
            ],
            [
                27 + variant3,
                30 + variant3,
                32 + variant3,
                34 + variant3,
                37 + variant3,
            ],
            [
                2.5 + variant4,
                3 + variant4,
                3.5 + variant4,
                4 + variant4,
                4.5 + variant4,
            ],
            [
                22 + variant5,
                25 + variant5,
                27 + variant5,
                29 + variant5,
                32 + variant5,
            ],
        ],
    ];
}

export {
    data_waste,
    data_stockout,
    data_heatmap,
    data_shelflife_default,
    data_shelflife_options,
    data_leadtime_default,
    data_leadtime_options,
    data_prioritization_default,
    data_preplist,
};
